module.exports = __webpack_public_path__ + "img/u1133.6b2c388a.svg";